import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField, MatOption, MatSelect } from '@angular/material/select';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';
import { AvatarComponent } from '../avatar/avatar.component';
import { AccountService } from 'src/app/services/account/account.service';
import { LanguageService } from 'src/app/services/account/language.service';

@Component({
  standalone: true,
  selector: 'app-account-profile-step',
  templateUrl: './profile-step.component.html',
  styleUrls: ['./profile-step.component.scss'],
  imports: [
    CommonModule, ReactiveFormsModule, MatCheckbox, MatOption, MatSelect, MatFormField,
    ModalOptionPanelComponent, AvatarComponent
  ]
})
export class ProfileStepComponent {
  @Input() formGroup: FormGroup | null = null;
  @Input() isEditMode: boolean = false;
  @Input() countryList: { name: string, dial_code: string, code: string }[] = [];
  @Input() backendErrorMsg: string | null = null;

  @Output() avatarProcessing = new EventEmitter<boolean>();
  @Output() changePassword = new EventEmitter<void>();
  @Output() deleteProfile = new EventEmitter<void>();
  @Output() downloadUserData = new EventEmitter<void>();

  @ViewChild('avatarComponent') avatarComponent: AvatarComponent | null = null;

  constructor(
    public accountService: AccountService,
    public languageService: LanguageService
  ) {}

  get registerFirstName() { return this.formGroup!.get('registerFirstName')!; }
  get registerLastName() { return this.formGroup!.get('registerLastName')!; }
  get registerCountry() { return this.formGroup!.get('registerCountry')!; }
  get registerPhone() { return this.formGroup!.get('registerPhone')!; }

  public initAvatar(): void {
    this.avatarComponent?.initAvatar();
  }

  public getAvatarFile(): File | string | null {
    return this.avatarComponent?.getAvatarFile() ?? null;
  }

  public onAvatarProcessing(processing: boolean): void {
    this.avatarProcessing.emit(processing);
  }
}
